import {css} from 'lit';

export const cssVars = css`
	:host {
		--font-widget-title: 500 13px "Lineto Brown Pro Regular", sans-serif;
		--font-widget-big-title: 300 27px "Lineto Brown Pro Light", sans-serif;
		--font-widget-small-title: 300 15px "Lineto Brown Pro Light", sans-serif;
		--font-widget-label: 500 13px "Lineto Brown Pro Light", sans-serif;
		--font-widget-big-label: 500 15px "Lineto Brown Pro Regular", sans-serif;
		--color-widget-text: #ffffff;
		--color-widget-infoicon: #606060;
		--color-widget-border: #606060;
		--color-widget-text-disabled: #606060;
		--color-widget-border-light: #C6C6C6;

		--font-widget-info: 300 13px "Lineto Brown Pro Light", sans-serif;
		--color-widget-info: #ffffff;

		--color-widget-background: #191919;
		--color-widget-background-hover: #313131;
		--color-widget-background-selected: #606060;
		--color-widget-background-selected-dark: #313131;
		--color-widget-background-light: #D9D9D9;

		--height-widget: 40px;

		--assistant-widget-width: 100%;
		--solar-assembly-title: 500 19px "Lineto Brown Pro Regular", sans-serif;

		--nav-button-tab-width: 40px;
		--nav-button-tab-height: 16px;
		--nav-button-height: 52px;
		--features-column-width: 320px;
		--features-column-gap: 48px;
	}
`;

export const staggeredReveal = css`
	:host {
		opacity: 0;
		animation: reveal 0.25s ease-out 0.5s 1 normal forwards;
	}

	:host(:nth-child(0)) {
		animation-delay: 0s
	}

	:host(:nth-child(1)) {
		animation-delay: 0.05s
	}

	:host(:nth-child(2)) {
		animation-delay: 0.1s
	}

	:host(:nth-child(3)) {
		animation-delay: 0.15s
	}

	:host(:nth-child(4)) {
		animation-delay: 0.2s
	}

	:host(:nth-child(5)) {
		animation-delay: 0.25s
	}

	:host(:nth-child(6)) {
		animation-delay: 0.3s
	}

	:host(:nth-child(7)) {
		animation-delay: 0.35s
	}

	:host(:nth-child(8)) {
		animation-delay: 0.4s
	}

	:host(:nth-child(9)) {
		animation-delay: 0.43s
	}

	:host(:nth-child(10)) {
		animation-delay: 0.46s
	}

	:host(:nth-child(11)) {
		animation-delay: 0.48s
	}

	:host(:nth-child(12)) {
		animation-delay: 0.5s
	}

	@keyframes reveal {
		from {
			opacity: 0;
			margin-top: -10px;
		}

		to {
			opacity: 100%;
			margin-top: 0px;
		}
	}
`;

export const widgetButton = css`
	button {
		width: 100%;
		font: var(--font-widget-label);
		color: var(--color-widget-text);
		background-color: transparent;
		display: inline-block;
		height: var(--height-widget);
		min-width: var(--height-widget);
		cursor: pointer;
		white-space: nowrap;
		transition: background-color 0.4s, color 0.4s;
		padding: 8px 16px;
		text-align: center;
		border: 0 none;
		box-shadow: 1px 0 0 0 var(--color-widget-border),
		0 1px 0 0 var(--color-widget-border),
		1px 1px 0 0 var(--color-widget-border),
		1px 0 0 0 var(--color-widget-border) inset,
		0 1px 0 0 var(--color-widget-border) inset;
	}

	button:hover {
		background-color: var(--color-widget-background-hover);
	}

	.selected button {
		background-color: var(--color-widget-background-selected);
	}

	.fixed button {
		pointer-events: none;
	}

	.disabled button {
		color: var(--color-widget-border);
	}

	.disabled button:hover {
		color: var(--color-widget-border);
	}
`;
